import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import PriceSwitcher from "./PriceSwitcher";
import IconCheck from "../images/discover/icon-check.png";
import PartnersUbiwan from "../images/partners/ubiwan-partner.png";
import PartnersSpartes from "../images/partners/spartes-partner.png";

function PricesBetonnier({ defaultType, onPaymentAbonnement, onPaymentCB }) {
  const [activeTab, setActiveTab] = useState(defaultType || "abonnements");

  return (
    <>
      <div className="discover-section text-center mb-4">
        <h2 className="mb-4">
          Nos tarifs pour <span>les bétonniers</span>
        </h2>
        <p className="discover-section-price-presentation-subtitle">
          SoluSpots vous propose différentes offres afin de répondre au mieux à
          vos besoins. <br />
          <span className="banner-title-colored">
            Choisissez celle qui vous correspond le mieux :
          </span>
        </p>
        <PriceSwitcher activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>

      {activeTab === "packs" && (
        <>
          <Row className="justify-content-center">
            <Col xs={12} md={9} xl={6} className="my-2 text-center">
              <p className="discover-section-price-presentation-subtitle">
                <strong>
                  Publiez en toute liberté, quand vous le souhaitez&nbsp;!
                </strong>
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xs={12} md={6} xl={5} className="my-4">
              <div className="discover-section-price-cards">
                <h3 className="discover-section-price-cards-pack-title">
                  <span>PACK 10</span>
                </h3>
                <h4 className="discover-section-price-cards-title">
                  Spotmonnaies
                </h4>
                <p className="discover-section-price-cards-subtitle">
                  Une annonce pour une date
                  <br />
                  coûte 1 Spotmonnaie
                </p>
                <div className="discover-section-price-cards-separator"></div>
                <p className="discover-section-price-cards-number">
                  <span className="discover-section-price-cards-number-special">
                    150 € <sup>HT*</sup>
                  </span>
                  <br />
                  <small>* soit 15 € HT / annonce</small>
                  <br />
                  <small className="promo-crossed">
                    + 99 € HT de frais uniques d'inscription
                  </small>
                </p>
                <div>
                  <div className="btn btn-danger">
                    Frais d’inscription OFFERTS&nbsp;!
                  </div>
                </div>
                <div className="discover-section-price-cards-separator"></div>
                <p className="mt-2">
                  Pour vos besoins ponctuels, publiez sans engagement avec un
                  pack pratique et flexible.
                </p>
                <div className="mt-4">
                  {onPaymentCB ? (
                    <a
                      className="solu-btn solu-btn-primary"
                      onClick={() => onPaymentCB("pack10")}
                    >
                      Je choisis le PACK 10
                    </a>
                  ) : (
                    <Link
                      to="/inscription"
                      className="solu-btn solu-btn-primary"
                    >
                      Je choisis le PACK 10
                    </Link>
                  )}
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={12} xl={10} className="my-4">
              <div className="discover-section-price-benefits">
                <h3 className="discover-section-price-benefits-title">
                  <span>
                    AVEC LE PACK, <span>VOUS BÉNÉFICIEZ DE :</span>
                  </span>
                </h3>
                <Row className="text-center">
                  <Col md={4}>
                    <img src={IconCheck} alt="" />
                    <h4>Flexibilité</h4>
                    <p>Achat selon vos besoins, sans engagement</p>
                  </Col>
                  <Col md={4}>
                    <img src={IconCheck} alt="" />
                    <h4>Tarification dégressive</h4>
                    <p>
                      Plus vous achetez de packs, plus vous économisez&nbsp;!
                    </p>
                  </Col>
                  <Col md={4}>
                    <img src={IconCheck} alt="" />
                    <h4>Simplicité</h4>
                    <p>Une annonce pour une date coûte 1&nbsp;Spotmonnaie</p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </>
      )}

      {activeTab === "abonnements" && (
        <>
          <Row className="justify-content-center">
            <Col xs={12} md={9} xl={6} className="my-2 text-center">
              <p className="discover-section-price-presentation-subtitle">
                <strong>
                  Publiez en illimité et boostez votre activité&nbsp;!
                </strong>
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xs={12} md={6} xl={5} className="my-4">
              <div className="discover-section-price-cards">
                <h4 className="discover-section-price-cards-title">
                  Abonnement
                </h4>
                <h3 className="discover-section-price-cards-pack-title">
                  <span>RÉGIONAL</span>
                </h3>
                <p className="discover-section-price-cards-subtitle">
                  Besoin d’une solution locale et efficace&nbsp;? Optez pour
                  l’abonnement régional et publiez en illimité dans votre zone
                  d’activité.
                </p>
                <div className="discover-section-price-cards-separator"></div>
                <div className="discover-section-price-cards-number">
                  <div className="discover-section-price-cards-number-special">
                    249,99€
                    <br />
                    <sup>HT/mois*</sup>
                  </div>
                  <div>
                    <small className="promo-crossed">
                      + 99 € HT de frais uniques d'inscription
                    </small>
                  </div>
                  <div>
                    <div className="btn btn-danger">
                      Frais d’inscription OFFERTS&nbsp;!
                    </div>
                  </div>
                  <div>
                    <strong>Pour un engagement 12 mois</strong>
                  </div>
                </div>
                <div className="discover-section-price-cards-separator"></div>
                <div className="mt-4">
                  {onPaymentAbonnement ? (
                    <a
                      className="solu-btn solu-btn-primary"
                      onClick={() => onPaymentAbonnement("regional")}
                    >
                      Je m'abonne en Régional
                    </a>
                  ) : (
                    <Link
                      to="/inscription"
                      className="solu-btn solu-btn-primary"
                    >
                      Je m'abonne en Régional
                    </Link>
                  )}
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} xl={5} className="my-4">
              <div className="discover-section-price-cards">
                <h4 className="discover-section-price-cards-title">
                  Abonnement
                </h4>
                <h3 className="discover-section-price-cards-pack-title">
                  <span>NATIONAL</span>
                </h3>
                <p className="discover-section-price-cards-subtitle">
                  Besoin d’une solution illimitée&nbsp;? Optez pour l’abonnement
                  national et publiez sans restriction partout en France&nbsp;!
                </p>
                <div className="discover-section-price-cards-separator"></div>
                <div className="discover-section-price-cards-number">
                  <div className="discover-section-price-cards-number-special">
                    499,99€
                    <br />
                    <sup>HT/mois*</sup>
                  </div>
                  <div>
                    <small className="promo-crossed">
                      + 99 € HT de frais uniques d'inscription
                    </small>
                  </div>
                  <div>
                    <div className="btn btn-danger">
                      Frais d’inscription OFFERTS&nbsp;!
                    </div>
                  </div>
                  <div>
                    <strong>Pour un engagement 24 mois</strong>
                  </div>
                </div>
                <div className="discover-section-price-cards-separator"></div>
                <div className="mt-4">
                  {onPaymentAbonnement ? (
                    <a
                      className="solu-btn solu-btn-primary"
                      onClick={() => onPaymentAbonnement("national")}
                    >
                      Je m'abonne en National
                    </a>
                  ) : (
                    <Link
                      to="/inscription"
                      className="solu-btn solu-btn-primary"
                    >
                      Je m'abonne en National
                    </Link>
                  )}
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={12} xl={10} className="my-4">
              <div className="discover-section-price-benefits">
                <h3 className="discover-section-price-benefits-title">
                  <span>
                    EN VOUS ABONNANT, <span>VOUS BÉNÉFICIEZ DE :</span>
                  </span>
                </h3>
                <Row>
                  <Col md={6}>
                    <div className="discover-section-price-benefits-item">
                      <div
                        className="discover-section-price-benefits-item-icon"
                        style={{ alignContent: "start" }}
                      >
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <img src={PartnersUbiwan} alt="" />
                        <h4>Offre Ubiwan dès l’inscription </h4>
                        <p>
                          Suivi en temps réel des véhicules et optimisation des
                          trajets
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="discover-section-price-benefits-item">
                      <div
                        className="discover-section-price-benefits-item-icon"
                        style={{ alignContent: "start" }}
                      >
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <img src={PartnersSpartes} alt="" />
                        <h4>Offre SPARTES</h4>
                        <p>
                          Audit gratuit et optimisation des coûts sociaux et
                          fiscaux
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="discover-section-price-benefits-item">
                      <div className="discover-section-price-benefits-item-icon">
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <h4>Annonces illimitées</h4>
                        <p>Durant l'abonnement</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="discover-section-price-benefits-item">
                      <div className="discover-section-price-benefits-item-icon">
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <h4>Notifications automatiques</h4>
                        <p>
                          Être informé lorsqu'un camion est près de votre
                          chantier
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="discover-section-price-benefits-item">
                      <div className="discover-section-price-benefits-item-icon">
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <h4>Visibilité prioritaire</h4>
                        <p>Pour vos annonces de chantiers</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="discover-section-price-benefits-item">
                      <div className="discover-section-price-benefits-item-icon">
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <h4>Support dédié</h4>
                        <p>pour toute question technique ou logistique</p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="discover-section-price-benefits-item">
                      <div className="discover-section-price-benefits-item-icon">
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <h4>
                          Rapports de performance <span>(à venir)</span>
                        </h4>
                        <p>
                          mensuels sur la visibilité des annonces et leur
                          performance
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="align-self-center">
                    <div className="discover-section-price-benefits-item">
                      <div className="discover-section-price-benefits-item-icon">
                        <img src={IconCheck} alt="" />
                      </div>
                      <div className="discover-section-price-benefits-item-text">
                        <h4>
                          Protocole de sécurité intégré <span>(à venir)</span>
                        </h4>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

export default PricesBetonnier;
